import ReportsDockContainer from 'modules/reports/components/Dock/Container'
import ReportsEditHeader from 'modules/reports/components/Edit/Header'
import ReportsEditSidebar from 'modules/reports/components/Edit/Sidebar'
import ReportsNav from 'modules/reports/components/Nav'
import ReportsPage from 'modules/reports/components/Page'
import ReportsSpreadsheet from 'modules/reports/components/Spreadsheet'
import ReportsSpreadsheetColumn from 'modules/reports/components/Spreadsheet/Column'
import useCore from 'modules/reports/hooks/core'
import React from 'react'
import {RouteComponentProps} from 'react-router'
import useStyles from './ReportsEdit.styles'

type Params = {
  id?: string
}

type Props = {} & RouteComponentProps<Params>

function ReportsEditPage(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'pages', 'Edit')

  const creating = !props.match.params.id
  const breadcrumbLabel = pt(`breadcrumb.${creating ? 'create' : 'edit'}`)

  const data = [
    {id: 1, name: 'John Doe', age: 24},
    {id: 2, name: 'John Doe', age: 25},
    {id: 3, name: 'John Doe', age: 25},
    {id: 4, name: 'John Doe', age: 25},
    {id: 5, name: 'John Doe', age: 25},
  ]

  return (
    <ReportsPage data-testid={p()}>
      <ReportsNav breadcrumbs={[{label: breadcrumbLabel}]} />
      <ReportsEditHeader />

      <div className={classes.horizontalWrapper}>
        <ReportsDockContainer>
          <ReportsEditSidebar className={classes.sidebar} />
        </ReportsDockContainer>

        <div className={classes.result}>
          <ReportsSpreadsheet prefix="" data={data} sort="">
            <ReportsSpreadsheetColumn name="id" />
            <ReportsSpreadsheetColumn name="name" />
            <ReportsSpreadsheetColumn name="age" />
          </ReportsSpreadsheet>
        </div>
      </div>
    </ReportsPage>
  )
}

export default ReportsEditPage
